// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"ebdc69a6","174":"dff28200","209":"3c42a45c","438":"98d2e0cf","456":"c80fee54","957":"0a498b17","991":"60c4eb6f"}[chunkId] + ".chunk.js";
};